import { GetStaticPropsContext } from 'next';

import Page, { getStaticProps as pageGetStaticProps } from './[...slug]';

export default Page;

export function getStaticProps(context: GetStaticPropsContext) {
  return pageGetStaticProps({
    ...context,
    params: {
      ...context.params,
      slug: ['home'],
    },
  });
}
